"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Box = _interopRequireDefault(require("../Containers/Box"));
var _IconButton = _interopRequireDefault(require("../Buttons/IconButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// TODO: replace this with something more useful or not export it at all, but
// implement it at a project level.
// Field array rows tend to have a different form:
// they don't have a background anymore
// they should use the DeleteIconButton
// they should use a GhostButton with text +Add to add a new row

var propTypes = {
  /** Content for the row, the form fields for that row */
  children: _propTypes["default"].node,
  /** The row's index, used to delete the row */
  index: _propTypes["default"].number,
  /** Formik's FieldArray arrayHelpers prop */
  arrayHelpers: _propTypes["default"].shape({
    remove: _propTypes["default"].func
  })
};
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "FieldArrayRow__Wrapper",
  componentId: "sc-1o7uojx-0"
})(["padding:", ";background:", ";padding-right:", ";position:relative;& + &{margin-top:", ";}"], function (props) {
  return props.theme.spaces.xs;
}, function (props) {
  return props.theme.colors.backgroundSecondary;
}, function (props) {
  return props.theme.fields.height;
}, function (props) {
  return props.theme.spaces.s;
});
var DeleteButton = (0, _styledComponents["default"])(_IconButton["default"]).withConfig({
  displayName: "FieldArrayRow__DeleteButton",
  componentId: "sc-1o7uojx-1"
})(["position:absolute;top:50%;right:0;transform:translateY(-50%);"]);
var FieldArrayRow = function FieldArrayRow(_ref) {
  var children = _ref.children,
    index = _ref.index,
    arrayHelpers = _ref.arrayHelpers;
  return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    d: "flex",
    alignItems: "center",
    gap: "s"
  }, children), /*#__PURE__*/_react["default"].createElement(DeleteButton, {
    onClick: function onClick(e) {
      e.preventDefault();
      arrayHelpers.remove(index);
    },
    name: "Clearclose",
    variant: "transparent",
    label: "Delete Row",
    color: "textSecondary",
    h: "fieldsHeight"
  }));
};
FieldArrayRow.propTypes = propTypes;
var _default = exports["default"] = FieldArrayRow;